import Vue from 'vue';
import PaytourCarousel from './components/PaytourCarousel.vue';

var youtubeApiReady = false;
window.onYouTubeIframeAPIReady = () => youtubeApiReady = true;
var queuedVideos = [];

function createVideo(video, cbPlayerStatusChange) {
    const videoId = video.getAttribute('data-video-id');
  
    const create = function (id, cb) {
        new window.YT.Player(video, {
            'videoId': id,
            'playerVars': {
                autoplay: 0,
                modestbranding: 1,
                rel: 0
            },
            'events': { 'onStateChange': cb, }
        });
    };

    if(youtubeApiReady) {
        create(videoId, cbPlayerStatusChange);
        queuedVideos.forEach(video => {
            create(video.id, video.cb);
        });
        queuedVideos = [];
    } else {
        queuedVideos.push({ id: videoId, cb: cbPlayerStatusChange });
    }
}

function onPlayerMobileStateChange(event) {
    if(event.data === 1) { // O usuário deu play no vídeo
        window.carouselVitrineMobilePasseio.pause();
        window.videoCarouselMobilePlaying = true;
        event.target.g.style.zIndex = 1000;
        document.getElementById('carouselVitrineMobile').classList.remove('d-md-none');
    } else {
        event.target.g.style.zIndex = 0;
    }
}

function onPlayerDesktopStateChange(event) {
    if(event.data === 1) { // O usuário deu play no vídeo
        window.carouselVitrineDesktopPasseio.pause();
    }
}

window.addEventListener('load', function() {
    // eslint-disable-next-line no-undef
    window.carouselVitrineMobilePasseio = new bootstrap.Carousel('#carouselVitrineMobile', { ride: 'carousel', pause: false });
    window.videoCarouselMobilePlaying = false;
    window.carouselVitrineMobilePasseio._element.addEventListener('slid.bs.carousel', function() {
        if(window.videoCarouselMobilePlaying) {
            setTimeout(() => {
                window.carouselVitrineMobilePasseio.pause();
            }, 1000);
        }
    });

    const videoMobile = this.document.getElementById('vitrine-mobile-video-player');
    const videoDesktop = this.document.getElementById('vitrine-desktop-video-player');
    if(videoMobile) {
        createVideo(videoMobile, onPlayerMobileStateChange);
    }
    if(videoDesktop) {
        createVideo(videoDesktop, onPlayerDesktopStateChange);
    }
});

const listaNodes = document.getElementsByClassName('payt-carousel');
for (let node of listaNodes) {
    createVueCarouselApp(node);
}

function createVueCarouselApp(node) {
    if(!node) {
        return;
    }
    const component = new Vue({
        el: node,
        components: { PaytourCarousel },
    });
    window.carouselVitrineDesktopPasseio = component.$children[0];
}
